export default __webpack_public_path__ + "static/media/unstaking-step-three-bnb-cbd.e66628b4.svg";